import * as React from 'react'
import type { SVGProps } from 'react'
function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Ebene 1"
      id="MS_Klimadashboard_Icons_wetter_neblig_svg__Ebene_1"
      viewBox="0 0 221.6 165.2"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="c">
        <g>
          <path
            d="M202.4,71.8C202.3,71.8,202.3,71.8,202.4,71.8c-1.8-22.8-21-41-44.2-41c-1.4,0-2.8,0.1-4.2,0.2c0,0,0,0,0,0
			c-9.7-18.9-29.3-31-50.7-31C77.9,0,56,16.3,48.7,40.2c0,0,0,0,0,0c-2.2-0.4-4.5-0.5-6.7-0.5C18.8,39.6,0,58.4,0,81.5
			c0,20.9,15.3,38.2,35.3,41.4c2.1,0.3,4-1.3,4-3.4v-0.1c0-1.7-1.3-3.1-3-3.4C19.7,113.3,7,98.9,7,81.5c0-19.2,15.6-34.9,34.9-34.9
			c2.8,0,5.7,0.3,8.4,1c0.9,0.2,1.9,0.1,2.7-0.4c0.8-0.5,1.4-1.3,1.6-2.2C60,22.7,80,7,103.1,7c19.5,0,37.4,11.5,45.5,29.3
			c0.7,1.4,2.2,2.2,3.7,2c1.9-0.3,3.9-0.4,5.8-0.4c20.3,0,37,16.5,37.3,36.8c0,1.7,1.3,3.2,3,3.5c9.3,1.5,16.1,9.5,16.1,18.9
			c0.1,10.7-9.1,19.4-19.8,19.4l-9,0c-1.9,0-3.5,1.6-3.5,3.5v0c0,1.9,1.6,3.5,3.5,3.5h8.9c14.5,0,26.9-11.9,26.9-26.3
			C221.5,85.1,213.6,74.9,202.4,71.8z"
          />
        </g>
        <g>
          <path d="M50.1,123.3h121.3c1.9,0,3.5-1.6,3.5-3.5s-1.6-3.5-3.5-3.5H50.1c-1.9,0-3.5,1.6-3.5,3.5S48.2,123.3,50.1,123.3z" />
          <path d="M133,140.7c0-1.9-1.6-3.5-3.5-3.5H50.1c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5h79.4C131.5,144.2,133,142.6,133,140.7z" />
          <path d="M171.4,158.2H92c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5h79.4c1.9,0,3.5-1.6,3.5-3.5S173.4,158.2,171.4,158.2z" />
        </g>
      </g>
    </svg>
  )
}
export default Icon
